import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskListPunctual = () => {
  return (
    <ContentCore />
  )
}

export default TaskListPunctual